var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _class3, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { render, Component, Prop, CustomElement, html, svg, Watch, nothing } from '@sick-davinci/ce-decorators';
import { style } from './Gauge.style';
import { SvgTools } from '../_utils/SvgTools.js';
import { statePaletteColors, resolveCssColor } from '../_utils/ColorTools.js';
import { ThemeService } from '../_utils/ThemeService.js'; // import theme, so color-variables can be resolved

import '@sick-davinci/theme-base/theme/light_theme.js';
import '@sick-davinci/theme-base/theme/light_ddg_theme.js';
import { NumberFormatter } from '../_utils/NumberFormatter.js';
import { CssTools } from '../_utils/CssTools.js';
/**
 * Stroke
 */

class Stroke {
  constructor() {
    this.color = 'black';
    this.width = 1.0;
    this.lineCap = 'round';
  }

}
/**
 * Section - one section of the gauge range
 */


class Section {
  constructor() {
    this.from = 0;
    this.to = 1;
    this.color = 'black';
    this.end = false;
  }

}

export
/**
 * Displays a number and the corresponding value-arc (tachometer style) within another colored sections-arc.
 *
 * @example
 * ```html
 * <div style="width: 300px; height: 300px">
 *  <davinci-gauge unit='&deg;C' value="50"></davinci-gauge>
 * </div>
 * ```
 */
let Gauge = (_dec = Component({
  tag: 'davinci-gauge',
  style
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Number), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Number), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Number), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", Object), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", Object), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", Boolean), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", String), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", Number), _dec18 = Prop(), _dec19 = Reflect.metadata("design:type", String), _dec20 = Prop(), _dec21 = Reflect.metadata("design:type", String), _dec22 = Prop(), _dec23 = Reflect.metadata("design:type", Boolean), _dec24 = Prop({
  type: Object,
  reflectAsAttribute: true
}), _dec25 = Reflect.metadata("design:type", Object), _dec26 = Prop(), _dec27 = Reflect.metadata("design:type", Object), _dec28 = Watch('absoluteScale'), _dec29 = Watch('sectionColors'), _dec30 = Watch('sections'), _dec31 = Watch('min'), _dec32 = Watch('max'), _dec33 = Reflect.metadata("design:paramtypes", []), _dec34 = Watch('value'), _dec35 = Reflect.metadata("design:paramtypes", [Number, Number]), _dec(_class = (_class2 = (_temp = _class3 = class Gauge extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "value", _descriptor, this);

    _initializerDefineProperty(this, "min", _descriptor2, this);

    _initializerDefineProperty(this, "max", _descriptor3, this);

    _initializerDefineProperty(this, "sections", _descriptor4, this);

    _initializerDefineProperty(this, "sectionColors", _descriptor5, this);

    _initializerDefineProperty(this, "absoluteScale", _descriptor6, this);

    _initializerDefineProperty(this, "unit", _descriptor7, this);

    this._valueFormatter = NumberFormatter.CREATE_DEFAULT();

    _initializerDefineProperty(this, "symbol", _descriptor8, this);

    _initializerDefineProperty(this, "indicatorColor", _descriptor9, this);

    _initializerDefineProperty(this, "trend", _descriptor10, this);

    _initializerDefineProperty(this, "trendset", _descriptor11, this);

    _initializerDefineProperty(this, "legendLabels", _descriptor12, this);

    this._setup = Gauge._setups;
    this._sections = [];
    this._trendAmount = 0;
  }

  /**
   * The number of decimal places to use. Possible values are from 0 to 10.
   *
   * If undefined no fixed number of decimal places will be used.
   *
   * @default undefined
   */
  set decimalPlaces(dp) {
    this._decimalPlaces = dp;
    this._valueFormatter = new NumberFormatter(false, dp);
  }

  get decimalPlaces() {
    return this._decimalPlaces;
  }

  /**
   * Called if attributes change
   */
  onChange() {
    if (!this.sectionColors) {
      this.sectionColors = [];
    }

    if (!this.sections) {
      this.sections = [];
    }

    this._calcSections();
  }

  onValueChange(ov, nv) {
    this._trendAmount = 0;

    if (this.trend) {
      this._trendAmount = (nv - ov) / Math.abs(ov) * 100; // in percent
    }
  }

  render() {
    var _this$legendLabels;

    if (((_this$legendLabels = this.legendLabels) === null || _this$legendLabels === void 0 ? void 0 : _this$legendLabels.length) > 0) {
      return html`
      <davinci-legend
        placement="N"
        compact
        small-font
        symbols='["box"]'
        symbol-size="${CssTools.REM2PIXEL(.7)}"
         .labels=${this.legendLabels}
         .colors=${this.sectionColors}>
        ${this._createSVG()}
      </davinci-legend>`;
    } else {
      return this._createSVG();
    }
  }

  componentConnected() {
    super.componentConnected();
    ThemeService.GET_INSTANCE().addListener(() => this.scheduleRender(true));
  }

  componentFirstRender() {
    this._calcSections();
  }

  _createArc(c, r, sd, ed, stroke) {
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('stroke', stroke.color);
    path.setAttribute('stroke-width', stroke.width.toString());
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke-linecap', stroke.lineCap);
    path.setAttribute('d', SvgTools.DESCRIBE_ARC(c.x, c.y, r, sd, ed));
    return path;
  }

  _createSect(sect) {
    const center = this._setup.center;
    const stroke = {
      color: sect.color,
      width: this._setup.scalar.width,
      lineCap: sect.end ? this._setup.cap : 'butt'
    };
    const a = this._setup.scalar.dAng * sect.from + this._setup.scalar.angMin;
    const b = this._setup.scalar.dAng * sect.to + this._setup.scalar.angMin;
    return this._createArc(center, this._setup.scalar.r, a, b, stroke);
  }

  _createScalar() {
    return svg`${this._sections.map(sect => svg` ${this._createSect(sect)}`)}`;
  }

  _createIndicator() {
    const center = this._setup.center;
    const si = this._setup.indicator;
    const stroke = {
      color: resolveCssColor('var(--davinci-color-background-3)'),
      width: si.widthBack,
      lineCap: this._setup.cap
    };
    const col = this.indicatorColor ? this.indicatorColor : this._calcIndicatorColor();
    const stroke2 = {
      color: col,
      width: si.width,
      lineCap: this._setup.cap
    };
    return svg`
      ${this._createArc(center, si.r, si.angMin, si.angMin + si.dAng, stroke)}
      ${this._createArc(center, si.r, si.angMin, this._getValAsDeg(), stroke2)}
    `;
  }

  _createTrendIndicator() {
    let cx = this._setup.center.x;
    const {
      y,
      w,
      h
    } = this._setup.trendPos;
    let unit = '%';

    if (this.trendset) {
      this._trendAmount = this.trendset.value;
      unit = this.trendset.unit;
    }

    if (this._trendAmount === 0) {
      return svg`${nothing}`;
    } // create trend text


    const ta = parseFloat(Math.abs(this._trendAmount).toFixed(1)) + unit;

    if (ta.indexOf('Infinity') >= 0 || ta.indexOf('e') >= 0 || ta.length > 6) {
      // don't display very small, very large or infinitiy value
      return svg`${nothing}`; // don't show trend if trend-value is meaningsless
    } // text size must be centered: calc the required space by rendering a the hidden text and determining its size


    const p = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    p.style.visibility = 'hidden';
    this.shadowRoot.appendChild(p);

    const txtTemplate = (x, y) => svg`<text transform="translate(${x} ${y})" id="trendText" text-anchor="start" font-size="${this._setup.trendTextSize}"><tspan>${ta}</tspan></text>`;

    render(txtTemplate(0, 0), p);
    const text = p.firstElementChild;
    const xcorr = text.getBBox().width / 2; // center correction

    p.remove();
    cx -= xcorr;
    const ti = {
      // trend-indicator points up- or down-wards
      up: [`${cx},${y}   ${cx - w / 2},${y + h} ${cx + w / 2},${y + h}`],
      down: [`${cx},${y + h} ${cx - w / 2},${y}   ${cx + w / 2},${y}`]
    };
    return svg`<polygon
      fill=${resolveCssColor('var(--davinci-color-text-lighter)')}
      points="${this._trendAmount >= 0 ? ti.up : ti.down}"></polygon>
      ${txtTemplate(cx + w, y + h)}
      `;
  } // tslint:disable:max-line-length
  // tslint:disable:no-unsafe-any


  _createTexts() {
    const su = this._setup;

    const val = this._valueFormatter.format(this.value);

    const min = NumberFormatter.TRIM_FLOAT(this.min, this.decimalPlaces);
    const max = NumberFormatter.TRIM_FLOAT(this.max, this.decimalPlaces);
    let s = this.symbol;
    const pos = this.symbol.indexOf('>');

    if (pos > 0) {
      s = s.replace(/\s*fill\s*=\s*".*?"/g, '');
      s = s.substring(0, pos) + ` fill="${resolveCssColor('var(--davinci-color-text-on-background)')}"` + s.substring(pos);
    }

    return svg`
    <foreignObject transform="translate(${su.indicatorTextPos})" font-size="${su.indicatorTextSize}" pointer-events="none" width="170" height="50" >
      <p id="indicatorText">${val}${this.unit}</p>
    </foreignObject>
    <foreignObject transform="translate(${su.indMinTextPos})" pointer-events="none" width="85" height="30" font-size="${su.indMinTextSize}" >
      <p id="indicatorMinText">${min}${this.unit}</p>
    </foreignObject>
    <foreignObject transform="translate(${su.indMaxTextPos})" pointer-events="none" width="85" height="30" font-size="${su.indMaxTextSize}" >
      <p id="indicatorMaxText">${max}${this.unit}</p>
    </foreignObject>
    <image id="symbol" transform="translate(${su.symbolPos})" width="${su.symbolSize}" height="${su.symbolSize}" href='${SvgTools.EMBED_SVG(s)}'></image>
    `;
  }

  _createSVG() {
    return svg`<svg id="davinci-gauge" viewBox="0 0 256 280" xmlns="http://www.w3.org/2000/svg">
    <g id="group" transform="translate(0 10) ">
      ${this._createScalar()}
      ${this._createIndicator()}
      ${this._createTexts()}
      ${this._createTrendIndicator()}
    </g>
    </svg>`;
  }

  _clamp(v, min, max) {
    return Math.min(Math.max(v, min), max);
  }

  _getValAsDeg() {
    const v = (this._clamp(this.value, this.min, this.max) - this.min) / (this.max - this.min);
    return v * this._setup.indicator.dAng + this._setup.indicator.angMin;
  }

  _calcSections() {
    let sections;
    let colors = this.sectionColors;
    let cLen = colors.length;
    const len = this.sections.length;
    this._sections = [];

    if (len >= 2) {
      sections = this.sections.sort((a, b) => a - b);

      if (cLen < 1) {
        cLen = 1;
        colors = [];
      }

      const min = this.absoluteScale ? this.min : sections[0];
      const max = this.absoluteScale ? this.max : sections[len - 1];

      for (let i = 1; i < len; i++) {
        const d = max - min;
        const from = (this._clamp(sections[i - 1], min, max) - min) / d;
        const to = (this._clamp(sections[i], min, max) - min) / d;
        const color = colors[(i - 1) % cLen];
        const end = i === 1 || i === len - 1;

        if (from >= 0 && from < 1 && to > from) {
          if (end) {
            this._sections.unshift({
              from,
              to,
              color,
              end
            });
          } else {
            this._sections.push({
              from,
              to,
              color,
              end
            });
          }
        }
      }
    }
  }

  _calcIndicatorColor() {
    let col = statePaletteColors[0];

    if (this._sections.length > 0) {
      const relVal = (this.value - this.min) / (this.max - this.min);

      this._sections.sort((a, b) => a.from - b.from).forEach(sec => {
        if (relVal >= sec.from && relVal < sec.to) {
          col = sec.color;
        }
      }); // handle out-of-bounds


      const lastSection = this._sections[this._sections.length - 1];
      const firstSection = this._sections[0];

      if (relVal >= lastSection.to) {
        col = lastSection.color;
      }

      if (relVal < firstSection.from) {
        col = firstSection.color;
      }
    }

    return col;
  }

}, _class3._setups = {
  scalar: {
    angMin: -126.0,
    dAng: 2 * 126.0,
    r: 125.0,
    width: 4
  },
  indicator: {
    angMin: -126.0,
    dAng: 2 * 126.0,
    r: 105.0,
    width: 24.0,
    widthBack: 19.0
  },
  symbolSize: 28,
  symbolPos: '114 135',
  indicatorTextSize: 33,
  indicatorTextPos: '46 82',
  indMaxTextSize: 19,
  indMaxTextPos: '129 195',
  indMinTextPos: '42 195',
  indMinTextSize: 19,
  cap: 'butt',
  center: {
    x: 128.,
    y: 128.
  },
  trendPos: {
    y: 250,
    w: 17,
    h: 14
  },
  trendTextSize: 19
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "value", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "min", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "max", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 100;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "sections", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [0, .04, .08, .92, .96, 1];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "sectionColors", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ['#ea0823', '#f5c413', '#63b017', '#f5c413', '#ea0823'];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "absoluteScale", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "unit", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '%';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "decimalPlaces", [_dec16, _dec17], Object.getOwnPropertyDescriptor(_class2.prototype, "decimalPlaces"), _class2.prototype), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "symbol", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "indicatorColor", [_dec20, _dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "trend", [_dec22, _dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "trendset", [_dec24, _dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "legendLabels", [_dec26, _dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, "onChange", [_dec28, _dec29, _dec30, _dec31, _dec32, _dec33], Object.getOwnPropertyDescriptor(_class2.prototype, "onChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onValueChange", [_dec34, _dec35], Object.getOwnPropertyDescriptor(_class2.prototype, "onValueChange"), _class2.prototype)), _class2)) || _class);
